import { render, staticRenderFns } from "./General.vue?vue&type=template&id=4e626b48&scoped=true&"
import script from "./General.vue?vue&type=script&lang=ts&"
export * from "./General.vue?vue&type=script&lang=ts&"
import style0 from "./General.vue?vue&type=style&index=0&id=4e626b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e626b48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4e626b48', component.options)
    } else {
      api.reload('4e626b48', component.options)
    }
    module.hot.accept("./General.vue?vue&type=template&id=4e626b48&scoped=true&", function () {
      api.rerender('4e626b48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SolicitudBajaSim/Crear/General.vue"
export default component.exports